import { render } from "./BubbleFact.vue?vue&type=template&id=37d4f356"
import script from "./BubbleFact.vue?vue&type=script&lang=js"
export * from "./BubbleFact.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__